<template>
  <div class="friends-light-page">
    <fn-friends-light-intro
      v-if="page?.content?.content_slots?.b"
      class="fl-intro"
      :content="page.content.content_slots.b"
    />

    <fn-toast
      :show="friendsLightError"
      class="fl-error-toast"
      type="error"
      :header="$t('friendsLight.toast.error.headline')"
      :text="$t('friendsLight.toast.error.text')"
      @close="closeToast"
    />

    <fn-cms-section-loader
      v-if="userLoggedInWithQrCode && page?.content?.content_slots?.a?.sections"
      :sections="page.content.content_slots.a.sections"
      sub-sections
    />

    <fn-app-promotion
      v-if="userLoggedInWithQrCode && page?.content?.content_slots?.c"
      class="fl-app-promotion"
      :headline="page?.content.content_slots?.c?.header_text || ''"
      :image-data="page?.content.content_slots?.c?.promotion_image || {}"
      :list-data="page?.content.content_slots?.c?.promotion_icon_text_list?.sections[0]?.['1']?.components?.[0] || []"
      :cta-data="page?.content.content_slots?.c?.app_download_image_links?.sections?.[0] || []"
    />
    <div
      class="fl-container"
      :style="{ transform: `translateY(${flContainerTranslateY})` }"
    >
      <fn-friends-light-reg-log v-if="!userLoggedInWithQrCode" />
      <fn-friends-light-general-terms />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    page: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    isRegistering: false,
  }),
  computed: {
    ...mapState(useMainStore, {
      isMobileView: 'isMobileView',
      sectionSmileHeight: 'sectionSmileHeight',
    }),

    ...mapState(useUserStore, {
      isAuthenticated: 'getIsAuthenticated',
    }),

    ...mapWritableState(useUserStore, {
      friendsLightError: 'friendsLightError',
      friendsLightQrCode: 'friendsLightQrCode',
      friendsLightActivated: 'friendsLightActivated',
    }),

    userLoggedInWithQrCode() {
      return this.isAuthenticated && this.friendsLightQrCode;
    },

    additionalHeight() {
      return this.isMobileView ? 72 : 80;
    },

    flContainerTranslateY() {
      return this.userLoggedInWithQrCode ? '0px' : `-${this.sectionSmileHeight + this.additionalHeight}px`;
    },
  },
  created() {
    this.closeToast();
    this.friendsLightActivated = false;
    this.friendsLightQrCode = null;
  },
  methods: {
    onRegisterBtnClick() {
      this.isRegistering = true;
    },
    closeToast() {
      this.friendsLightError = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.friends-light-page {
  display: flex;
  flex-direction: column;
  align-items: center;

  :deep(.sections) {
    width: 100%;
    margin: 2.5 * $pad 0;

    @include bp(m, max) {
      padding: 0 $pad;
    }
  }

  .fl-container {
    transition: all 0.3s ease;
  }

  .fl-error-toast {
    position: absolute;
    top: 240px;
    left: 50%;
    transform: translateX(-50%);
    right: 0;
    z-index: 100;
    max-width: 300px;
  }

  :deep(.section-content) {
    max-width: $content-max-width;
  }

  .fl-intro {
    width: 100%;
  }
}
</style>
